import React, { type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import CustomerHeader from './CustomerHeader';

interface CustomerLayoutProps {
  children: ReactNode;
  showCartBadge?: boolean;
}

const CustomerFooter = () => (
  <footer className="bg-white border-t mt-auto hidden md:block">
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="text-center text-gray-500 text-sm">
        <p>© {new Date().getFullYear()} The Wright Tech Depot. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

const CustomerLayout: React.FC<CustomerLayoutProps> = ({
  children,
  showCartBadge = true
}) => {
  const location = useLocation();
  const { cart } = useCart();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <CustomerHeader />

      {/* Main Content */}
      <main className="flex-1 pb-16 md:pb-0">
        {children}
      </main>

      {/* Footer */}
      <CustomerFooter />
    </div>
  );
};

export default CustomerLayout;